import locale_am from "./locales/am.json";

const translations = {
    am: locale_am
};

export default translations;